<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle>
    Additional Revenue/Expenses for: {{ workOrderNumber }}
  </div>
  <button mat-icon-button class="close-btn" (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="mat-typography">
  <div class="toolbar">
    <!-- @if(revenuePermissions.ShowRevenueAddButton){ -->
    <button mat-raised-button color="primary" data-testid="btnAddRevenue" (click)="onAddRow()">
      <mat-icon>add</mat-icon> Add New
    </button>
    <!-- } -->
  </div>
  <div class="mat-elevation-z2 viewport gridheight">
    <table mat-table [dataSource]="dataSource" [trackBy]="trackByRevenueId" style="table-layout: fixed;">
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let row">
          <!-- @if(revenuePermissions.ShowRevenueGridActions){ -->
            <div style="margin-left: -13px;">
              <button mat-icon-button type="button" class="icon-btn edit-icon" title="Edit" (click)="onEditRow(row)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button type="button" color="warn" title="Delete" (click)="onDeleteRow(row.id, row.name)" style="color: red;">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          <!-- } -->
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Name </th>
        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
      </ng-container>

      <ng-container matColumnDef="invoiceNumber">
        <th mat-header-cell *matHeaderCellDef> Invoice # </th>
        <td mat-cell *matCellDef="let row">{{ row.invoiceNumber }}</td>
      </ng-container>

      <ng-container matColumnDef="price">
        <th mat-header-cell *matHeaderCellDef> Price </th>
        <td mat-cell *matCellDef="let row">{{ row.price | number:'1.0-4' }}</td>
      </ng-container>

      <ng-container matColumnDef="expenseType">
        <th mat-header-cell *matHeaderCellDef> Expense Type </th>
        <td mat-cell *matCellDef="let row">{{ getExpenseTypeName(row.expenseType) }}</td>
      </ng-container>

      <ng-container matColumnDef="expensive">
        <th mat-header-cell *matHeaderCellDef> Bill to<br />customer? </th>
        <td mat-cell *matCellDef="let row">{{ row.expensive ? 'Yes' : 'No' }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">No additional revenues/expenses found.</td>
      </tr>
    </table>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" mat-primary (click)="onClose()">Close</button>
</mat-dialog-actions>

